import { createSelector } from 'reselect';

const getMetadataSchemaData = (state) => state.widgetData.metadataSchemaData;

const selectUploadFiles = createSelector(getMetadataSchemaData, (data) => data.files);

const selectSchema = createSelector(getMetadataSchemaData, (data) => data.schema);

const selectHasConflictedFiles = createSelector(getMetadataSchemaData, (data) => !!(data.conflictedFiles && data.conflictedFiles.length));

const selectUploadCancel = createSelector(getMetadataSchemaData, (data) => data.cancelUpload);

export { selectUploadFiles, selectSchema, selectUploadCancel, selectHasConflictedFiles };
